module.exports = __webpack_public_path__ + "static/media/remove.a4767f9a.svg";